import React from 'react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section className="w-full bg-rink-deep" data-id="element-457" data-mp="2bwe6imbbrd3g">
      <div className="max-w-3xl mx-auto px-5 py-14 sm:py-16 text-center" data-id="element-458" data-mp="2bvcrk6r6u6gg">
        <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-amber" data-id="element-459" data-mp="1x06lxkw089nn">
          Launch offer
        </p>
        <h2 className="mt-3 font-display font-bold text-white text-2xl sm:text-4xl" data-id="element-460" data-mp="21x6x2a7po2lm">
          The launch price ends in:
        </h2>
        <div className="mt-6" data-id="element-461" data-mp="1o58ruah4equq">
          <Countdown tone="dark" data-id="element-462" data-mp="1sybq2vwueoh9" />
        </div>
        <p className="mt-5 text-sm text-white/70" data-id="element-463" data-mp="1sz4nv7dtq3n9">
          After that the price goes up by{' '}
          <span className="font-semibold text-coral-soft" data-id="element-464" data-mp="1eaqjut4o8954">$5</span> and stays
          there.
        </p>
      </div>
    </section>;
}